export const informationToRead = {
  title: 'Information to read',
  happy: `
    <p>
    Hope and optimism are good for mental and physical health. A
    diagnosis of dementia can bring with it uncertainty and even fear.
    That is all the more reason to do things that spark joy and make you
    smile. If you do not feel in good spirits it is important to tell
    someone close to you. Hiding, or trying to cope with difficult
    feelings on your own can make you feel worse.
  </p>
    `,
  relaxed: `<p>Peace and quiet often help us to feel calm and relaxed. So does being in a comfortable
    environment.</p>
<p>It is helpful to have a familiar physical space that you enjoy spending time in, perhaps a
    favourite chair with photos of loved ones nearby.</p>
<p>Having a regular daily routine that you are accustomed to and includes things that you
    enjoy will also help you to feel confident and relaxed.</p>` ,
  active: `<p>Feeling able to do the things that you would like to do is important.</p>
  <p>Maintaining your physical health and wellbeing will help with this. This includes managing any other conditions you may have, managing your medications and looking after your general health.</p>`,
  rested: `<p>Sleeping well is important and poor sleep patterns have been linked to poor physical and mental health. Most older
  adults find 7-9 hours of sleep is enough. Common sleep problems include difficulty falling asleep, staying asleep or
  waking early in the morning.</p>
<p>NHS Inform has information on sleeping well in its <a rel="noopener"
      href="https://www.nhsinform.scot/illnesses-and-conditions/mental-health/insomnia" target="_blank"
      title="NHS Inform: Insomnia">insomnia section</a></p>
<p>If sleeping is a problem for you, you'll find some helpful tips in the Activities to try tab.</p>`,
  interests: `<p>There are many benefits of doing things that you enjoy and find meaningful.</p>
  <p>There are things you can do at home such as cooking, baking, household tasks and gardening. It is also good to try new things and do activities outside of the home that give you an opportunity to connect with others.</p>
  <p>It is important that you still do things that you enjoy. This can be things you like doing in your own home or in your local community. Research shows that doing things you enjoy will help you adapt and cope with stress.</p>`,
};

export default informationToRead;
